import type {TDashboardDataResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TFormError, TGameId} from '@kapitalist/contract/types'
import type {EmptyObject} from '@kapitalist/utils/EmptyObject'
import {PostApi} from '~/api/client'
import dashboardDataMock from '~/api/endpoints/dashboard/GetDashboardData/mock'

const endpoint = endpoints.dashboard.markGameAsStale

/**
 * Active games listed on the dashboard can be removed from the list by their
 * creator, e.g. if the game was abandoned. This will hide it for all users.
 */
export default class MarkGameAsStale extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(
    params: EmptyObject,
    pathPieces: {gameId: TGameId}
  ): TFormError | null {
    if (pathPieces.gameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): TDashboardDataResponse {
    return dashboardDataMock
  }

  protected transformResponse(r: TDashboardDataResponse) {
    return r
  }
}
